import { RootState } from 'store/types';

export * from './patients/selectors';

export const CovidScreeningSelector = (state: RootState) => state.covidScreening;
export const CovidScreeningPatientInfoSelector = (state: RootState) =>
  state.covidScreening?.patient;
export const CovidScreeningSubscriberSelector = (state: RootState) =>
  state.covidScreening?.subscriber;
export const CovidScreeningQuestionnaireSelector = (state: RootState) =>
  state.covidScreening?.questionnaire;
export const CovidScreeningInsuranceCardSelector = (state: RootState) =>
  state.covidScreening?.insuranceCard;
export const CovidScreeningInsuranceListSelector = (state: RootState) =>
  state.covidScreening?.insuranceList;
export const CovidScreeningOrderStatus = (state: RootState) => state.covidScreening?.orderStatus;
